<template>
  <el-card>
    <h1>{{ langData.report }}</h1>
    <!-- 搜索 -->
    <el-row class="search" :class="{ ar: isAr == 2 }">
      <el-col :xs="24" :lg="3">
        <el-date-picker v-model="startDate" value-format="yyyy-MM-dd" type="date" style="width: 100%"
          :placeholder="langData.selectData">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="1">
        <span>{{ langData.rid }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-input style="width: 100%" v-model="search.rid"></el-input>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.hostLevel }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-select style="width: 100%" v-model="search.level" clearable class="selec">
          <el-option :label="langData.all" :value="null"> </el-option>
          <el-option v-for="(item, index) in levelList" :key="index" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="3">
        <span>{{ langData.activeHost }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-select v-model="search.active" clearable style="width: 100%">
          <el-option :label="langData.all" :value="null"> </el-option>
          <el-option :label="langData.active" :value="1"> </el-option>
          <el-option :label="langData.inActive" :value="0"> </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.country }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-select style="width: 100%" v-model="search.countryCode" clearable filterable>
          <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country" :value="item.code">
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :lg="2" style="width: max-content">
        <el-button type="primary" @click="query(1)">{{
          langData.search
        }}</el-button>
      </el-col>
      <el-col :xs="12" :lg="2">
        <el-button type="primary" plain icon="el-icon-plus" v-loading="dwnLoading" @click="download">{{ langData.export
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="list" v-loading="loading" border :class="{ ar: isAr == 2 }" max-height="550">
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" width="180" sortable prop="date"
          :label="langData.date"></el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" width="180" sortable prop="countryCode"
          :label="langData.country"></el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" width="180" sortable prop="name"
          :label="langData.name">
          <template slot-scope="scope">
            <span class="notranslate">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" width="180" sortable prop="rid"
          :label="langData.rid"></el-table-column>
        <el-table-column min-width="180" sortable prop="appraiseScore"
          :label="langData.appraiseScore">
          <template slot-scope="scope">
            {{ formatAppraiseScore(scope.row.appraiseScore) }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" sortable prop="onlineDuration" :label="langData.onlineDuration"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="180" sortable prop="liveDuration" :label="langData.liveDuration"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="180" sortable prop="answerRate" :label="langData.answerRate">
          <template slot-scope="scope">
            {{ `${(scope.row.answerRate * 100).toFixed(2)}%` }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" sortable prop="personalCallAvgTime" :label="langData.personalCallAvgTime"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="190" sortable prop="matchCallAvgTime" :label="langData.matchCallAvgTime"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="230" sortable prop="totalCallTime" :label="langData.matchCallCount"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="180" sortable prop="personalCallIncomeUSD" :label="langData.personalCallIncomeUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.personalCallIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column min-width="190" sortable prop="matchCallIncomeUSD" :label="langData.matchCallIncomeUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.matchCallIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" sortable prop="giftIncomeUSD" :label="langData.giftIncomeUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.giftIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" sortable prop="totalIncomeUSD" :label="langData.totalIncomeUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.totalIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" sortable prop="currDiamonds" :label="langData.currDiamonds">
          <template slot-scope="scope">
            {{ `${Math.round(scope.row.currDiamonds * cr)}` }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination layout="prev, pager, next" :total="this.total" :page-size="this.pageSize"
        :hide-on-single-page="true" @current-change="handleCurrentChange" :pager-count="isMobile ? 5 : 7">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getData, downloadDetail } from '@/api/report.js'
import { reportData } from '@/utils/lang.js'
import { getCountryList } from '@/api/operate.js'
import { downloadFile } from '@/utils/download.js'
import { cr } from '@/config'

export default {
  data() {
    return {
      cr: cr,
      loading: false,
      dwnLoading: false,
      list: [],
      startDate: '',
      langData: {},
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      isAr: parseInt(sessionStorage.getItem('lang')),
      isMobile: window.innerWidth <= 768,
      levelList: [
        {
          name: 'C',
          value: 0,
        },
        {
          name: 'B',
          value: 1,
        },
        {
          name: 'A',
          value: 2,
        },
        {
          name: 'S',
          value: 3,
        },
      ],
      search: {
        rid: null,
        active: null,
        level: null,
        countryCode: null,
      },
      countryList: [],
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
      currentPage: 1,
      total: 0,
      pageSize: 100,
    }
  },
  created() {
    if (sessionStorage.getItem('lang')) {
      this.langData = reportData[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '1')
      this.langData = reportData[1]
    }
    this.startDate = this.formatYYYYMMDD(new Date())
    this.getCountryCode()
    this.query(1)

    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = reportData[val]
      this.isAr = val
    },
  },
  methods: {
    handleCurrentChange(page) {
      console.log(page);
      this.currentPage = page
      this.query()
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    // 格式化日期为YYYY-MM-DD格式，确保月和日是两位数
    formatYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    download() {
      this.dwnLoading = true
      downloadDetail(
        {
          // startDate: this.startDate,
          ...this.search,
          startDate: this.startDate,
          lang: ['en', 'zh', 'ar', 'es'][this.isAr || 0],
          page: -1
        },
        1
      )
        .then((response) => {
          console.log(response)
          this.dwnLoading = false
          this.$message.success('开始下载')
          downloadFile(response.data, this.langData.report)
        })
        .finally(() => {
          this.dwnLoading = false
        })
    },
    // appraiseScore 映射：L0=C, L1=B, L2=A, L3=S，找不到则显示原值
    formatAppraiseScore(val) {
      const map = { L0: 'C', L1: 'B', L2: 'A', L3: 'S' }
      return map[val] != null ? map[val] : (val ?? '')
    },
    formatDate(row, column) {
      if (!row[column.property]) return '0h:0m:0s'
      const time = row[column.property]
      const hours = Math.floor(time / 3600)
      const minutes = Math.floor((time % 3600) / 60)
      const seconds = (time % 60).toFixed(0)
      return `${hours}h:${minutes}m:${seconds}s`
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query(page) {
      if (page) {
        this.currentPage = page
      }
      if (!this.startDate) {
        return this.$message({
          message: this.langData.selectData,
          center: true,
          type: 'error',
        })
      }
      this.loading = true
      try {
        const { data: res } = await getData({
          startDate: this.startDate,
          ...this.search,
          countryCode: this.search.countryCode || null,
          page: this.currentPage,
        })
        if (res.code !== 0) {
          this.$message({
            message: res.msg,
            center: true,
            type: 'error',
          })
          return
        }
        this.$message({
          message: res.msg,
          center: true,
          type: 'success',
        })
        this.list = res.data.data
        this.total = res.data.total
      } catch (error) {
        console.error(error)
        this.$message({
          message: this.langData.networkError || '网络错误',
          center: true,
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query()
    },

    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await getCountryList()
      this.countryList = res.data.countryList
    },
  },
}
</script>

<style lang="scss" scoped></style>